import { axiosinstance } from '../axiosClient';

const getSettings = async (
  axiosprivate: any,
  auth: any,
  locationId: string,
) => {
  const response = await axiosprivate.get(
    `/bp_get-location-settings/${locationId}`,
    {
      headers: { Authorization: 'Bearer ' + auth?.accessToken },
    },
  );
  return response;
};

const getRemoteAppVersion = async () => {
  const response = await axiosinstance.get('/bp_app_update_version');
  return response;
};

export { getSettings, getRemoteAppVersion };
